"use strict";import{ButtonBase as t}from"./ButtonBase.js";import r from"./button-base.css.js";export class StyledButton extends t{static get styles(){return[r]}}
//# sourceMappingURL=StyledButton.js.map
